'use strict';

var _ = require('lodash');
var ChartDemandTransparencyDataProviderService = function ChartDemandTransparencyDataProviderService($filter, dtConstants, retrieverConstants, seasonColorService, profileLevelStrategyProvider, dataRetrieverService, svgPatternService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var EXCLUSION = 'exclusion';
  var NODATA = 'no data';
  var MAPPING = {
    'Total Bookings': 'reservationHoldingsTotal',
    'Grp Bookings': 'reservationHoldingsGroup',
    'Idv Bookings': 'reservationHoldingsIdv',
    'Untruncated Bookings': 'untruncatedReservationHoldings',
    'Remaining Demand': 'remainingUntruncatedReservationHoldings'
  };
  function retrieveData(dataDimension, selectedMetric, carrier, market, spos, classGroup, lpd, rtp) {
    return dataRetrieverService.getDtdChartDataRetriever(dataDimension, selectedMetric, carrier, market, spos, classGroup, lpd, rtp).localSortApplied().retrieveComponentData(retrieverConstants.DTD_CHART);
  }
  function flattenColorsMap(colorsMap) {
    return _.transform(colorsMap, function (result, n, season) {
      var uniqueColors = _.chain(n).values().uniq().value();
      if (uniqueColors.length === 1) {
        result[season] = uniqueColors[0];
      } else {
        _.forOwn(n, function (color, downGroup) {
          result[season + ' (' + downGroup + ')'] = color;
        });
      }
    });
  }
  function adjustOverlay(d, dataDimension) {
    var isRegular = dataDimension === dtConstants.DATA_DIMENSION.REGULAR;
    if (d) {
      var isOverlaid = isRegular && d.isRegularOutlier || !isRegular && d.isMappedOutlier;
      d.overlay = isOverlaid ? 'user-exclusion' : undefined;
      d.overlayViewport = isOverlaid ? 'user-exclusion-viewport' : undefined;
    }
  }
  function transformData(data, dataDimension, selectedMetric, attrs, quickFilterData) {
    if (data === undefined) {
      return {
        data: undefined,
        legend: undefined
      };
    }
    var colorsMap = {};
    var lastDepartureDate;
    var mapping = MAPPING[selectedMetric];
    var strategy = profileLevelStrategyProvider.getStrategy(attrs.profileLevel || 'MQ_SPOS_DOWG');
    function getFillData(season, dowGroup) {
      var barColor = strategy.getFillData(quickFilterData, season, dowGroup);
      _.set(colorsMap, season + '.' + dowGroup, barColor.color);
      return barColor;
    }
    function isPreviousElementGap(elements) {
      return elements.length > 0 && elements[elements.length - 1].isGap;
    }
    function isGapBetweenDates(lastDepartureDate, newElement) {
      return lastDepartureDate && !newElement.departureDate.subtract(1, 'days').isSame(lastDepartureDate, 'day');
    }
    var seasons = {};
    var dowGroups = {};
    var result = _.chain(data).sortBy('departureDate').reduce(function (result, d) {
      if (quickFilterData.classGroup === d.classGroupName) {
        var lastRtp = _.last(d.daysToDepartures);
        var rtpData = _.first(d.daysToDepartures);
        var singleDtd = _.isArray(d.daysToDepartures) && d.daysToDepartures.length === 1;
        var fillData = getFillData(d.season, d.dowGroup);
        var overrideFillData = d.seasonOverride ? getFillData(d.seasonOverride, d.dowGroup) : undefined;
        if (isGapBetweenDates(lastDepartureDate, d) && !isPreviousElementGap(result)) {
          result.push({
            d1: lastDepartureDate.add(1, 'days'),
            isGap: true
          });
        }
        var entity = {
          d1: d.departureDate,
          m1: rtpData.untruncatedResHold[mapping],
          m1Rtp: quickFilterData.dtd,
          m2: lastRtp.untruncatedResHold[mapping],
          m2Rtp: lastRtp.daysToDeparture,
          singleDtd: singleDtd,
          stackLabel: rmMomentFormat(d.departureDate, 'DATE_ISO'),
          fill: d.seasonOverride && overrideFillData ? overrideFillData.color : fillData.color,
          opacity: 1,
          isVisible: fillData.isVisible,
          carrier: d.carrier,
          productGroup: d.classGroupName,
          pos: d.significantPOS,
          season: d.season,
          seasonOverride: d.seasonOverride,
          fillOverride: d.seasonOverride ? fillData.color : undefined,
          dowGroup: d.dowGroup,
          isRegularOutlier: d.isRegularOutlier,
          isMappedOutlier: d.isMappedOutlier
        };
        lastDepartureDate = d.departureDate;
        if (entity.isVisible) {
          result.push(entity);
          adjustOverlay(entity, dataDimension);
        }
        seasons[entity.season] = true;
        dowGroups[entity.dowGroup] = true;
      }
      return result;
    }, []).value();
    var legend = flattenColorsMap(colorsMap);
    var staticLegend = {};
    staticLegend[NODATA] = svgPatternService.getPatternUrl('user-exclusion');
    staticLegend[EXCLUSION] = svgPatternService.getPatternUrl('user-exclusion');
    var legendMapped = _.map(legend, function (color, label) {
      return {
        label: _.startCase(_.lowerCase(_.replace(label, '-', ' '))),
        fill: color
      };
    });
    var staticLegendMapped = _.map(staticLegend, function (color, label) {
      return {
        label: label,
        fill: color
      };
    });
    var chartAttributes = {
      seasons: _.keys(seasons),
      dowGroups: _.keys(dowGroups),
      maxDtd: _.chain(result).map('m2Rtp').max().value()
    };
    return {
      data: result,
      legend: legendMapped,
      staticLegend: staticLegendMapped,
      chartAttributes: chartAttributes
    };
  }
  function getData(attrs, quickFilterData, dataDimension, selectedMetric) {
    return retrieveData(dataDimension, selectedMetric, attrs.carrier, attrs.market, attrs.spos, quickFilterData.classGroup, attrs.lastProcessedMoment, quickFilterData.dtd).then(function (data) {
      return transformData(data, dataDimension, selectedMetric, attrs, quickFilterData);
    });
  }
  return {
    getData: getData,
    adjustOverlay: adjustOverlay
  };
};
ChartDemandTransparencyDataProviderService.$inject = ['$filter', 'DemandTransparencyConstants', 'DataRetrieverConstantsService', 'SeasonColorService', 'ProfileLevelStrategyProviderService', 'DemandTransparencyDataRetrieverService', 'SvgPatternService'];
module.exports = ChartDemandTransparencyDataProviderService;